// import {combineReducers} from "redux";
import providerConnection from './auth';

const authReducer = providerConnection;

export default authReducer;
